module.exports = __webpack_public_path__ + "img/taiyang.3a669d12.png";